export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13930.fe7e75ab.jpg";